import { render, staticRenderFns } from "./KbWorkspaceManage.vue?vue&type=template&id=a4310d14&scoped=true"
import script from "./KbWorkspaceManage.vue?vue&type=script&lang=js"
export * from "./KbWorkspaceManage.vue?vue&type=script&lang=js"
import style0 from "./KbWorkspaceManage.vue?vue&type=style&index=0&id=a4310d14&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4310d14",
  null
  
)

export default component.exports